export const priceListSelector = state => state.priceListReducer;
